var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeRotate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.555664,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#EF7707"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08333 13.7625C6.90694 13.6167 5.93229 13.1038 5.15937 12.224C4.38646 11.3441 4 10.3111 4 9.125C4 8.48333 4.12639 7.8684 4.37917 7.28021C4.63194 6.69201 4.99167 6.17917 5.45833 5.74167L6.28958 6.57292C5.92014 6.90347 5.64062 7.2875 5.45104 7.725C5.26146 8.1625 5.16667 8.62917 5.16667 9.125C5.16667 9.98056 5.43889 10.7365 5.98333 11.3927C6.52778 12.049 7.22778 12.45 8.08333 12.5958V13.7625ZM9.25 13.7625V12.5958C10.0958 12.4403 10.7934 12.0368 11.3427 11.3854C11.892 10.734 12.1667 9.98056 12.1667 9.125C12.1667 8.15278 11.8264 7.32639 11.1458 6.64583C10.4653 5.96528 9.63889 5.625 8.66667 5.625H8.62292L9.26458 6.26667L8.44792 7.08333L6.40625 5.04167L8.44792 3L9.26458 3.81667L8.62292 4.45833H8.66667C9.96944 4.45833 11.0729 4.91042 11.9771 5.81458C12.8813 6.71875 13.3333 7.82222 13.3333 9.125C13.3333 10.3014 12.9469 11.3295 12.174 12.2094C11.401 13.0892 10.4264 13.6069 9.25 13.7625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRotate);
export default __webpack_public_path__ + "static/media/orange_rotate.a305240493db9cc34713537d15911278.svg";
export { ForwardRef as ReactComponent };